import { CardTest } from "../styles/Card";

const ViewNumberFour = ({ formInvest, setFormInvest }) => {
  // Choice One
  const onChangeChoiceOne = (e) => {
    let value = e.target.value;
    if (value === "one") {
      setFormInvest({
        ...formInvest,
        four_question_choice_one: formInvest.four_question_choice_one
          ? false
          : true,
      });
    }
  };

  // Choice Two
  const onChangeChoiceTwo = (e) => {
    let value = e.target.value;
    if (value === "two") {
      setFormInvest({
        ...formInvest,
        four_question_choice_two: formInvest.four_question_choice_two
          ? false
          : true,
      });
    }
  };

  // Choice Three
  const onChangeChoiceThree = (e) => {
    let value = e.target.value;
    if (value === "three") {
      setFormInvest({
        ...formInvest,
        four_question_choice_three: formInvest.four_question_choice_three
          ? false
          : true,
      });
    }
  };

  // Choice Four
  const onChangeChoiceFour = (e) => {
    let value = e.target.value;
    if (value === "four") {
      setFormInvest({
        ...formInvest,
        four_question_choice_four: formInvest.four_question_choice_four
          ? false
          : true,
      });
    }
  };

  return (
    <div className=" bg-gray50 p-4 mt-5 rounded-[10px] ">
      <div className=" text-maincyan text-xs">คำถามที่ 4 จาก 10</div>
      <CardTest
        cantwochoice={true}
        name1="1"
        name2="2"
        name3="3"
        name4="4"
        choice1={<div>เงินฝากธนาคาร</div>}
        choice2={
          <div>
            พันธบัตรรัฐบาล
            <div>หรือกองทุนรวมพันธบัตรรัฐบาล</div>
          </div>
        }
        choice3={<div>หุ้นกู้ หรือกองทุนรวมตราสารหนี้</div>}
        choice4={
          <div>
            หุ้นสามัญ หรือกองทุนรวมหุ้น
            <div>หรือสินทรัพย์อื่นที่มีความเสี่ยงสูง</div>
          </div>
        }
        value1={"one"}
        value2={"two"}
        value3={"three"}
        value4={"four"}
        onChange1={onChangeChoiceOne}
        onChange2={onChangeChoiceTwo}
        onChange3={onChangeChoiceThree}
        onChange4={onChangeChoiceFour}
        checked1={formInvest?.four_question_choice_one}
        checked2={formInvest?.four_question_choice_two}
        checked3={formInvest?.four_question_choice_three}
        checked4={formInvest?.four_question_choice_four}
        question="4. ท่านเคยมีประสบการณ์หรือมีความรู้
        ในการลงทุนในทรัพย์สินกลุ่มใดต่อไปนี้บ้าง"
        sub="(สามารถเลือกได้มากกว่า 1 ข้อ)"
      />
    </div>
  );
};

export default ViewNumberFour;
